import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ColorPickerModesEnum} from '../../common/color/colorPicker';
import {ColorPickerDropdown} from '../../common/color/colorPickerDropdown';
import {StyledCalendarDropdownBoxCoordinator} from './calendarDropdownBoxBase';

/*
 * Props.
 */

interface CalendarColorDropdownBoxProps {
  color: PaletteColorsEnum;
  onColorSelect: HandlerOf<PaletteColorsEnum>;
  className?: string;
}

/*
 * Style.
 */

const StyledValueDiv = styled.div`
  height: 20px;
  display: flex;
`;

/*
 * Component.
 */

export const CalendarColorDropdownBox: FC<CalendarColorDropdownBoxProps> = (props) => (
  <StyledCalendarDropdownBoxCoordinator
    value={renderValue(props)}
    renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
    boxClassName={props.className}
  />
);

function renderValue(props: CalendarColorDropdownBoxProps) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledValueDiv>
          <Icon name="calendarColorSmall" color={theme.palette[props.color].shade40} />
        </StyledValueDiv>
      )}
    </UserThemeConsumer>
  );
}

function renderDropdown(popoverProps: PopoverTransferProps, props: CalendarColorDropdownBoxProps) {
  return (
    <ColorPickerDropdown
      {...popoverProps}
      color={props.color}
      onColorSelect={(colorValue, paletteColor) => {
        if (paletteColor) {
          props.onColorSelect(paletteColor);
        }

        popoverProps.onRequestClose();
      }}
      mode={ColorPickerModesEnum.WITH_GREY}
    />
  );
}
